import React from "react";
import { FaGlobe } from "react-icons/fa";

import './experience.styles.scss';

const Experience = ({ title, link, icon, languages, tools, time, description }) => (
  <div className='experience'>
    <div className='experience-left'>
      <img alt={title} src={icon} className='experience-icon' />
    </div>

    <div className='experience-text'>
      <div className='experience-header'>
        <h1 className='experience-title'>{title}</h1>
        <a target='_blank' rel='noreferrer' href={link} className='experience-link'><FaGlobe size={30} /></a>
      </div>
      <p className='experience-content'>
        <b>Languages: </b>{languages.join(', ')}<br />
        <b>Tools: </b>{tools.join(', ')}<br />
        <b>Time: </b>{time}<br />
        <b>Description: </b>{description}<br />
      </p>
    </div>

    <hr className='mid' />
  </div>
);

export default Experience;
